import { list, create, update, fetchUser, deleteUser, createOnChecklist } from './hausefulUsersService'
import { errorMessages } from '@/util/helpers'
import Vue from 'vue'

const state = {
  hausefulUser: {},
  hausefulUsers: [],
  isHausefulUserSaving: false,
  isHausefulUserLoading: false,
  isHausefulUserDeleting: false,
}

const getters = {
  hausefulUser: (state) => state.hausefulUser,
  hausefulUsers: (state) => state.hausefulUsers,
  isHausefulUserSaving: (state) => state.isHausefulUserSaving,
  isHausefulUserLoading: (state) => state.isHausefulUserLoading,
  isHausefulUserDeleting: (state) => state.isHausefulUserDeleting,
}

const actions = {
  async fetchHausefulUsers({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await list(params)
      const { result, total } = data

      commit('setHausefulUsers', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', errorMessages(data.errors))
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async fetchHausefulUser({ commit, dispatch }, hausefulUserId) {
    commit('setIsHausefulUserLoading', true)

    try {
      const { data } = await fetchUser(hausefulUserId)
      commit('setHausefulUser', data)
    } catch ({data}) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', errorMessages(data.errors))
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsHausefulUserLoading', false)
    }
  },

  async saveHausefulUser({ commit, dispatch }, hausefulUser) {
    commit('setIsHausefulUserSaving', true)

    try {
      hausefulUser.id ? await update(hausefulUser) : await create(hausefulUser)
      commit('closeAllModals')
      dispatch('showSuccessMessage', Vue.i18n.translate(`hausefulUsers.messages.${hausefulUser.id ? 'successfullyEdited' : 'successfullyCreated'}`))
      dispatch('fetchHausefulUsers')
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', errorMessages(data.errors))
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsHausefulUserSaving', false)
    }
  },

  async deleteHausefulUser({ commit, dispatch }, hausefulUserId) {
    commit('setIsHausefulUserDeleting', true)

    try {
      await deleteUser(hausefulUserId)
      commit('closeAllModals')
      dispatch('fetchHausefulUsers')
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', errorMessages(data.errors))
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsHausefulUserDeleting', false)
    }
  },

  async createHausefulUserOnChecklist({ commit, dispatch }, body) {
    commit('setIsLoading', true)

    await createOnChecklist(body)
      .then(() => {
        commit('closeAllModals')
        dispatch('fetchHausefulUsers')
        dispatch('showSuccessMessage', Vue.i18n.translate('userChecklistModal.successfullyCreated'))
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  handleShowHausefulUsersDetails({ commit, dispatch }, hausefulUserId) {
    commit('setHausefulUser', {})
    commit('setIsDrawerOpen', true)
    hausefulUserId && dispatch('fetchHausefulUser', hausefulUserId)
  },

  handleOpenCreateUpdateHausefulUsersModal({ dispatch, commit }, hausefulUserId) {
    commit('setHausefulUser', {})
    dispatch('openModal', 'CREATE_UPDATE_HAUSEFUL_USER_MODAL')
    hausefulUserId && dispatch('fetchHausefulUser', hausefulUserId)
  },

  handleOpenCreateUserOnChecklistModal({ dispatch, commit }, hausefulUserId) {
    commit('setHausefulUser', {})
    hausefulUserId && dispatch('fetchHausefulUser', hausefulUserId)
    dispatch('openModal', 'CREATE_USER_ON_CHECKLIST_MODAL')
  },

  handleOpenDeleteHausefulUsersModal({ dispatch, commit }, hausefulUserId) {
    commit('setHausefulUser', {})
    dispatch('openModal', 'DELETE_HAUSEFUL_USER_MODAL')
    hausefulUserId && dispatch('fetchHausefulUser', hausefulUserId)
  },
}

const mutations = {
  setHausefulUser: (state, user) => {
    state.hausefulUser = user
  },

  setHausefulUsers: (state, users) => {
    state.hausefulUsers = users
  },

  setIsHausefulUserLoading: (state, status) => {
    state.isHausefulUserLoading = status
  },

  setIsHausefulUserSaving: (state, status) => {
    state.isHausefulUserSaving = status
  },

  setIsHausefulUserDeleting: (state, status) => {
    state.isHausefulUserDeleting = status
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
